import Button from 'components/common/button';
import emojiData from './emoji_data';
import EmojiIcon from 'components/lib/icons/emoji_picker_icon';
import { NimblePicker } from 'emoji-mart';
import PopoverMenu, { usePopoverMenu } from 'components/common/menu';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import Theme from 'scripts/presentation/themes/default.js';
import TrackEmojiUsage from 'actions/composer/track_emoji_usage';
import { useExecuteAction } from 'components/hooks/connect_hooks';

// icons
import AppleIcon from 'components/lib/icons/apple_icon';
import CarIcon from 'components/lib/icons/car_icon';
import ClockIcon from 'components/lib/icons/clock_icon';
import DogIcon from 'components/lib/icons/dog_icon';
import FlagIcon from 'components/lib/icons/flag_icon';
import LightBulbIcon from 'components/lib/icons/lightbulb_icon';
import SoccerBallIcon from 'components/lib/icons/soccer_ball_icon';
import SymbolsIcon from 'components/lib/icons/symbols_icon';

const Emoji = ({ editor }) => {
  const { targetRef, setTargetRef, isOpen, onClose, onToggle } = usePopoverMenu();

  const insertEmoji = useInsertEmoji(editor, onClose);
  const icons = {
    categories: {
      recent: () => <ClockIcon />,
      people: () => <EmojiIcon />,
      nature: () => <DogIcon />,
      foods: () => <AppleIcon />,
      activity: () => <SoccerBallIcon />,
      places: () => <CarIcon />,
      objects: () => <LightBulbIcon />,
      symbols: () => <SymbolsIcon />,
      flags: () => <FlagIcon />,
    },
  };
  return (
    <React.Fragment>
      <EmojiButton data-aid={`slateEmoji-button`} onClick={onToggle} ref={setTargetRef}>
        <StyledEmojiIcon />
      </EmojiButton>
      <StyledMenu
        margin={0}
        data-aid={`slateEmoji-menu`}
        isOpen={isOpen}
        onClose={onClose}
        position="bottom"
        targetPosition="start"
        targetRef={targetRef}
      >
        <NimblePicker
          data={emojiData}
          notFoundEmoji="mag"
          color={Theme.colors.gray600}
          onSelect={insertEmoji}
          icons={icons}
          native
          title=""
          emojiTooltip
          showPreview={false}
          showSkinTones={false}
          emoji=""
          style={{ minWidth: '394px' }}
        />
      </StyledMenu>
    </React.Fragment>
  );
};

export function useInsertEmoji(editor, onClose) {
  const executeAction = useExecuteAction();
  return useCallback(
    emoji => {
      editor.focus();
      editor.insertText(emoji.native);
      executeAction(TrackEmojiUsage, { name: emoji.name });
    },
    [editor, executeAction]
  );
}

export default Emoji;
const EmojiButton = styled(Button)`
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  color: inherit;
  display: flex;
  height: 25px;
  justify-content: center;
  margin: 0 4px;
  padding: 0;
  min-width: 25px;
  &:focus {
    border: 1px solid ${p => p.theme.colors.gray200};
    border-radius: 4px;
  }
  &:hover {
    background: transparent;
    border: 1px solid ${p => p.theme.colors.gray200};
    border-radius: 4px;
  }
`;

const StyledEmojiIcon = styled(EmojiIcon)`
  fill: ${p => p.theme.colors.gray900};
  height: 13px;
  width: 13px;
`;

const StyledMenu = styled(PopoverMenu)`
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 4px rgba(0, 0, 0, 0.1);
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/shared/emoji.jsx